import React from "react";
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetFooter,
    SheetTrigger,
} from "@/components/ui/sheet";
import { TriggerButtons } from "@/components/units/action/TriggerButtons";
import { Drawer as ShadDrawer } from "../ui/drawer";

interface DrawerProps {
    isOpen: boolean;
    setIsOpen: (val: boolean) => void;
    children: React.ReactNode;
}

export const Drawer = ({ isOpen, setIsOpen, children }: DrawerProps) => (
    <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild={true}>
            <TriggerButtons />
        </SheetTrigger>
        <SheetContent
            className="se-vapor se-vapor-drawer tw:flex-col tw:max-h-screen tw:w-[390px] tw:px-0 no-scrollbar tw:z-max"
            onInteractOutside={(e) => e.preventDefault()}
        >
            <ShadDrawer>
                <SheetHeader className="tw:h-full">{children}</SheetHeader>
                <SheetFooter />
            </ShadDrawer>
        </SheetContent>
    </Sheet>
);
